// extracted by mini-css-extract-plugin
export var btn = "customerFeaturedCard-module--btn--9d15d";
export var btnTertiary = "customerFeaturedCard-module--btnTertiary--253bd";
export var buttonContainer = "customerFeaturedCard-module--buttonContainer--c76cb";
export var contentWrapper = "customerFeaturedCard-module--contentWrapper--6076b";
export var copy = "customerFeaturedCard-module--copy--7c34d";
export var curtain = "customerFeaturedCard-module--curtain--aa535";
export var customerButton = "customerFeaturedCard-module--customerButton--05402";
export var customerCardOuter = "customerFeaturedCard-module--customerCardOuter--cbb4f";
export var logo = "customerFeaturedCard-module--logo--a0709";